import { render, staticRenderFns } from "./FooterGeneral.vue?vue&type=template&id=2cc255db&scoped=true&"
import script from "./FooterGeneral.vue?vue&type=script&lang=ts&"
export * from "./FooterGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./FooterGeneral.vue?vue&type=style&index=0&id=2cc255db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc255db",
  null
  
)

export default component.exports